import { joinStringsWithSeparator } from '@modules/common/utils';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { getLinkableIntegrationTypes } from '@modules/integrationsV2/utils';
import { Alert } from '@mui/material';
import { IntegrationType } from 'generated/graphql';
import { capitalize } from 'lodash';

interface IntegrationSourceDetailAlertMessageProps {
  integrationSource: IntegrationSource;
}

export const IntegrationSourceDetailAlertMessage = ({
  integrationSource,
}: IntegrationSourceDetailAlertMessageProps) => {
  if (
    integrationSource.isDisabled &&
    integrationSource.integrationType !== IntegrationType.Cohorts
  ) {
    const linkableIntegrationTypes = getLinkableIntegrationTypes(
      integrationSource.integrationType,
    );

    const supportedTypesLabel = joinStringsWithSeparator({
      strings: linkableIntegrationTypes.map(capitalize),
      lastSeparatorWord: 'and',
    });

    return (
      <Alert
        severity="info"
        sx={{
          border: '1px solid',
          borderColor: 'info.main',
        }}
      >
        This integration is disabled. Previously ingested data is still
        available for analysis and can be linked with {supportedTypesLabel}{' '}
        integrations.
      </Alert>
    );
  }

  return null;
};
